import { $ } from "../lib/format";
import { ACCENT, ACCENT2, AMBER, BG, BG2, BORDER, CARD, DARK, DIM, MID, RED } from "../theme";
import { useState } from "react";

// ─── TAB: RAW DATA ────────────────────────────────────────────────────────────

function RawData({ jobSummaries }) {
  const [view, setView] = useState("jobs");

  // Build flat lists from live jobSummaries
  const liveJobs = jobSummaries.map(j => ({
    id: j.id, name: j.name, clientName: j.clientName,
    type: j.type, status: j.status,
  }));

  const liveInvoices = jobSummaries.flatMap(j =>
    j.invoices.map(inv => ({
      id: inv.Id, docNumber: inv.DocNumber, jobName: j.name,
      txnDate: inv.TxnDate, totalAmt: inv.TotalAmt, balance: inv.Balance,
      description: inv.Line?.[0]?.Description || '—',
    }))
  );

  const liveExpenses = jobSummaries.flatMap(j =>
    j.purchases.map(p => ({
      id: p.Id, docNumber: p.DocNumber, vendor: p.EntityRef?.name || '—',
      jobName: j.name, txnDate: p.TxnDate, totalAmt: p.TotalAmt,
      description: p.Line?.[0]?.Description || '—',
    }))
  );

  const VIEWS = [
    { key:"jobs",     label:"Jobs",     count: liveJobs.length },
    { key:"invoices", label:"Invoices", count: liveInvoices.length },
    { key:"expenses", label:"Expenses", count: liveExpenses.length },
  ];

  return (
    <div className="r-page" style={{ padding:"32px 36px", background:BG, minHeight:"100vh" }}>
      <div style={{ marginBottom:24 }}>
        <h1 style={{ fontFamily:"'Lora',serif", fontSize:24, fontWeight:600, color:DARK, letterSpacing:"-0.02em", marginBottom:4 }}>
          Raw Data
        </h1>
        <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize:13, color:DIM, marginBottom:18 }}>
          Live data synced from your QuickBooks account.
        </p>
        <div className="r-wrap" style={{ display:"flex", gap:8 }}>
          {VIEWS.map(v => (
            <button key={v.key} className={`btn${view===v.key?" act":""}`} onClick={()=>setView(v.key)}>
              {v.label} <span style={{ opacity:0.55, fontSize:10, marginLeft:4 }}>({v.count})</span>
            </button>
          ))}
        </div>
      </div>

      <div className="card" style={{ overflow:"hidden" }}>
        <div className="r-scroll" style={{ overflowX:"auto" }}>
          {view==="jobs" && (
            <table className="raw-table">
              <thead><tr>{["ID","Job Name","Client","Type","Status"].map(h=><th key={h}>{h}</th>)}</tr></thead>
              <tbody>
                {liveJobs.map((j,i) => (
                  <tr key={i}>
                    <td style={{ padding:"8px 12px" }} title={j.id}><span style={{ fontFamily:"'DM Mono',monospace",fontSize:10,color:DIM,background:BG2,padding:"2px 6px",borderRadius:4 }}>{j.id.slice(0,8)}</span></td>
                    <td style={{ color:DARK, fontWeight:500 }}>{j.name}</td>
                    <td style={{ color:MID }}>{j.clientName}</td>
                    <td><span className="tag">{j.type}</span></td>
                    <td><span style={{ color:j.status==="Complete"?DIM:j.status==="In Progress"?DIM:AMBER, fontSize:11, fontFamily:"'DM Sans',sans-serif" }}>{j.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {view==="invoices" && (
            <table className="raw-table">
              <thead><tr>{["Doc #","Job","Date","Amount","Balance","Description"].map(h=><th key={h}>{h}</th>)}</tr></thead>
              <tbody>
                {liveInvoices.map((inv,i) => (
                  <tr key={i}>
                    <td className="mono">{inv.docNumber}</td>
                    <td style={{ color:DARK, fontWeight:500 }}>{inv.jobName}</td>
                    <td className="mono">{inv.txnDate}</td>
                    <td className="mono" style={{ color:ACCENT2 }}>{$(inv.totalAmt||0)}</td>
                    <td className="mono" style={{ color:inv.balance>0?AMBER:DIM }}>{$(inv.balance||0)}</td>
                    <td style={{ color:MID, maxWidth:240 }}>{inv.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {view==="expenses" && (
            <table className="raw-table">
              <thead><tr>{["Doc #","Vendor","Job","Date","Amount","Description"].map(h=><th key={h}>{h}</th>)}</tr></thead>
              <tbody>
                {liveExpenses.map((p,i) => (
                  <tr key={i}>
                    <td className="mono">{p.docNumber}</td>
                    <td style={{ color:DARK, fontWeight:500 }}>{p.vendor}</td>
                    <td style={{ color:MID }}>{p.jobName}</td>
                    <td className="mono">{p.txnDate}</td>
                    <td className="mono" style={{ color:RED }}>{$(p.totalAmt||0)}</td>
                    <td style={{ color:MID, maxWidth:240 }}>{p.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <div style={{ marginTop:20, padding:"16px 20px", borderRadius:5, border:`1px solid ${BORDER}`, background:CARD, fontSize:12, color:DIM, lineHeight:1.7, fontFamily:"'DM Sans',sans-serif" }}>
        <span style={{ color:ACCENT, fontWeight:500 }}>Source: </span>
        Live data from your QuickBooks account. Expenses tagged to jobs appear here; expenses without a job appear in Expense Management.
      </div>
    </div>
  );
}

export { RawData };
